import classnames from 'classnames';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers, withProps, withState } from 'recompose';
import { blur, Field } from 'redux-form';
import { INDETERMINATE } from './constants';

const FieldComponent = forwardRef((props, ref) => {
  const { input, meta, prefix, className, placeholder, showVaries, handleVariesClick } = props;
  const placeholderValue = (placeholder && !input.value) ? placeholder : '';

  return (
    <div className="u-position-relative">
      <div className="c-prefix u-inline-block" display-if={prefix}>{prefix}</div>
      <div className="c-input-with-indeterminate">
        <div
          className={classnames(
            'indeterminate-label',
            className,
            { 'c-input--prepend': prefix, 'indeterminate-label__hidden': !showVaries }
          )}
          onClick={handleVariesClick}
        >
          Varies
        </div>
        <input
          {...input}
          {...omit(props, ['input', 'meta'])}
          required={input.value === INDETERMINATE ? false : props.required}
          style={{ opacity: showVaries ? 0 : 1 }}
          className={classnames(
            'input-field',
            className,
            { 'c-input--prepend': prefix, 'input-field__hidden': showVaries }
          )}
          placeholder={placeholderValue}
          ref={ref}
        />
      </div>
      <div className="c-input-error-message" display-if={meta.touched && meta.error}>{meta.error}</div>
    </div>
  );
});

FieldComponent.propTypes = {
  prefix: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }).isRequired,
};

FieldComponent.defaultProps = {
  prefix: '',
  className: '',
  placeholder: '',
};

const IndeterminateInputContainer = compose(
  connect(null, { blur }),
  withState('showVaries', 'setShowVaries', props => props.input.value === INDETERMINATE),
  withHandlers({
    handleVariesClick: props => () => {
      props.setShowVaries(false);
      document.querySelector(`input[name="${props.input.name}"]`)
        .focus();
    },
    onBlur: props => () => {
      if (props.input.value === INDETERMINATE || (props.input.value === '' && props.meta.initial === INDETERMINATE)) {
        props.setShowVaries(true);
        // We intercept blur so we can send INDETERMINATE
        props.blur(props.meta.form, props.input.name, INDETERMINATE);
      }
    },
  }),
  withProps(props => ({
    input: {
      ...props.input,
      onBlur: props.onBlur,
    },
  }))
)(FieldComponent);

const InputWithIndeterminate = ({ prefix, ...props }) => (
  <Field
    prefix={prefix}
    component={IndeterminateInputContainer}
    {...props}
  />
);

export default InputWithIndeterminate;
